import React, { useState, useEffect  } from 'react';
import Snackbar from '@mui/material/Snackbar'; 
import CustomSnackbar from './Optics/Components/CustomSnackbar';
import RegistrationDialog from './RegistrationDialog';
import { handleLogin } from './Optics/AuthorizationData/AuthorizationUser';
import { PING_API_URL } from './Optics/OpticApiConfig';

const Authorization = ({ setToken }) => {
  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [openModalRegistration, setOpenModalRegistration] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState(''); 

  useEffect(() => {
    const fetchPing = async () => {
      try {
        const response = await fetch(PING_API_URL, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        });
        if (response.ok) {
          const data = await response.text();
          showSnackbar(data, 'success');
        } else {
          const errorData = await response.text();
          showSnackbar(`Error: ${errorData}`, 'error');
        }
      } catch (error) {
        showSnackbar(`Error: ${error.message}`, 'error');
      }
    };

    fetchPing();
  }, []);


  const handleLoginClick = () => {
    handleLogin(username, password, setToken, showSnackbar);
  };



  const openModalRegistrationComponents = () => {
    setOpenModalRegistration(true);
  };

  return (  
    <div className='divAuthorization'>
        <div className='divAuthorization2'>
            <label style={{color: "#e4a700", fontStyle: "unset", fontSize: "24px",fontWeight: 'bold', fontFamily: 'Arial, sans-serif'}}>OpticMap</label>
            <hr/>
             
            <input 
                className='inputAuth'
                type="text"
                placeholder="логин" 
                value={username} 
                onChange={(e) => setUsername(e.target.value)} 
            />
            
            <input 
                className='inputAuth' 
                type="password" 
                value={password} 
                placeholder="пароль" 
                onChange={(e) => setPassword(e.target.value)} 
            />
        
        <button className='buttonLogin' onClick={handleLoginClick}>Вход</button>

        {/* <hr/> 
        <label onClick={openModalRegistrationComponents} className="registrationLabel">регистрация</label>
        */}
        </div>
      
        <img 
          src='./logo.png'
          className='logo'
          alt='Logo'
          style={{
            height: "400px",
            width: "400px",
            animation: "rotate 40s linear infinite",   
          }}
        />

      <style>
        {`
          @keyframes rotate {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>

        <RegistrationDialog
          open={openModalRegistration}
          onClose={() => setOpenModalRegistration(false)}
        />

         {/* Snackbar */}
       <Snackbar
          anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
          }}
          open={snackbarOpen}
          autoHideDuration={2000}
          onClose={handleCloseSnackbar}
          message={snackbarMessage}
          ContentProps={{
            style: {
              color: snackbarClass === 'snackbarOk' ? '#ffbb00' : '#ffbb00'
            }
          }}
        />
     
    </div>   
  );
};

export default Authorization;



